/*
 * Searchanise rekent prijzen correct om naar de valuta van de bezoeker, maar
 * toont elke andere valuta dan de winkelvaluta als "$1,234.56" (ook CZK, CHF,
 * ...). Dit script zet het bedrag opnieuw in Shopify's eigen opmaak voor die
 * valuta, zodat het overzicht overeenkomt met de productpagina.
 *
 * layout/theme.liquid geeft die opmaak mee als voorbeeld: het bedrag
 * 1234567,89 geformatteerd door Shopify (bv. "1.234.567,89 CZK"). Daaruit
 * halen we voor- en achtervoegsel, scheidingstekens en aantal decimalen.
 */
(function () {
  var sample = window.wfSnizeMoneySample;
  if (!sample) return;

  var decoder = document.createElement('textarea');
  decoder.innerHTML = sample;
  sample = decoder.value;

  var firstDigit = sample.search(/\d/);
  if (firstDigit === -1) return;
  var lastDigit = sample.length - 1 - sample.split('').reverse().join('').search(/\d/);

  var prefix = sample.slice(0, firstDigit);
  var suffix = sample.slice(lastDigit + 1);
  var core = sample.slice(firstDigit, lastDigit + 1);

  // Het voorbeeld heeft 7 cijfers voor de komma; de rest zijn decimalen.
  var decimals = core.replace(/\D/g, '').length - 7;
  if (decimals < 0 || decimals > 3) return;

  var decimalSeparator = decimals > 0 ? core.charAt(core.length - decimals - 1) : '';
  var integerPart = decimals > 0 ? core.slice(0, core.length - decimals - 1) : core;
  var thousandsSeparator = /\d/.test(integerPart.charAt(1)) ? '' : integerPart.charAt(1);

  function format(amount) {
    var parts = amount.toFixed(decimals).split('.');
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    return prefix + integer + (decimals > 0 ? decimalSeparator + parts[1] : '') + suffix;
  }

  function firstTextNode(element) {
    for (var i = 0; i < element.childNodes.length; i++) {
      var node = element.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) return node;
    }
    return null;
  }

  function reformat(element) {
    try {
      var textNode = firstTextNode(element);
      if (!textNode || textNode.nodeValue === element.getAttribute('data-wf-formatted')) return;

      // Snize schrijft altijd "1,234.56": komma's zijn duizendtallen.
      var numbers = textNode.nodeValue.match(/\d[\d,.]*/g);
      if (!numbers || numbers.length !== 1) return;
      var amount = parseFloat(numbers[0].replace(/,/g, ''));
      if (isNaN(amount)) return;

      var formatted = format(amount);
      textNode.nodeValue = formatted;
      element.setAttribute('data-wf-formatted', formatted);
    } finally {
      element.setAttribute('data-wf-ready', '');
    }
  }

  function processAll() {
    pending = false;
    document.querySelectorAll('.snize-price, .snize-discounted-price').forEach(reformat);
  }

  // Verbergt Snize-prijzen tot ze herschreven zijn (zie snize-filters.css),
  // pas nu het formaat geldig is gebleken.
  document.documentElement.classList.add('wf-snize-reformat');

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(processAll);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  processAll();
})();
